import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subscription, SubscriptionLicense } from '../../../shared/models/plans';
import { AccountSettingsService } from '../../account-settings.service';

@Component({
  selector: 'cc-plans-panel',
  templateUrl: './plans-panel.component.html',
  styleUrls: ['./plans-panel.component.scss']
})
export class PlansPanelComponent implements OnInit {
  @Input() private currentSubscription: Subscription;
  @Input() public panelForm: FormGroup;
  @Input() isUserLimitReached;
  @Input() isNotEnoughUsers;
  public plan: SubscriptionLicense;
  public interval: string;

  constructor(private accountSettingsService: AccountSettingsService) {}

  ngOnInit() {
    this.accountSettingsService.getSubscription().subscribe(subscription => {
      this.currentSubscription = subscription;
      this.interval = this.currentSubscription.licenses[0].interval;
      if (this.interval === 'P1Y') {
        this.panelForm.controls['billingPeriod'].setValue('P1Y');
      }
    });
  }
}
